<template>
	<div class="cotent_who">
		<div class="content_top">
			<img src="@/assets/images/who/banner.jpg" alt="" class="w100">
			<!-- <h3>Who We Are</h3> -->
		</div>
		
		<div class="content_icon">
			<h3>Research ability<h3>
			<ul>
				<li v-for="(item,index) in piclist" :key="index" >
					<img :src="item.show_img" alt="" class=""/>
					<h4>{{item.show_name}}</h4>
					<p>{{item.show_text}}</p>
				</li>
			</ul>
            <p class="des">{{des}}</p>
		</div>
	</div>
</template>

<script>
    import axios from 'axios';
	export default {
		data() {
			return {
				piclist:[],
                des:''
			}
		},
        mounted(){
        	var that = this;
        	axios({
        		method: 'get',
        		url:`${this.$apiYf}/indexlunboapi.php?cid=24`,
        		data: {
        			
        		},
        		headers: {'Content-Type': 'multipart/form-data'},
        	}).then((res) =>{
        		that.piclist=res.data.lunboinfo;
        	    
        	})
            axios({
        		method: 'get',
        		url:`${this.$apiYf}/shiliintroapi.php`,
        		data: {
        			
        		},
        		headers: {'Content-Type': 'multipart/form-data'},
        	}).then((res) =>{
        		that.des=res.data.show_list[1].show_text;
        	    
        	})
        	
        }
	}
</script>

<style scoped lang="scss">
    .cotent_who{
        .content_center{
        	width:100%;padding: 4.6875vw 0;
        	.container{display: flex;justify-content: space-between;align-items: flex-end;}
        	.team_text{width: 54%;
        		h4{font-size: 20px;color: #333;margin: 1vw 0 0.5vw;line-height: 1.8;}
        		p{font-size: 16px;color: #666;line-height: 1.8;text-align: justify;}
        	}
        	.team{
        		width: 42%;margin-bottom:1.5vw;
        	}
        	h3{font-size: 48px;color: #ad1f24;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #ad1f24;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	
        }
        .content_bottom{
        	position: relative;background: url(../../assets/images/who/who_bg.jpg) no-repeat center;background-attachment: fixed;height:calc(100vw / 1920 * 800);background-size: cover;
        	.container{
        		height: 100%;display: flex;align-items: center;position: relative;left:0;right: 0;top:0;margin: auto;
        		.icon_box{height: 100%;display: flex;align-items: center;
        		ul{width:80%;height: calc(100vw / 1920 * 800);
        			li{width:49.5%;height: 33.3333%;display: flex;
        			flex-direction: column;padding:5% 5% 0;transition: all .9s ease;
        			&:hover{
        				img{display: none;}
        				background: rgba(12,79,162,0.85);
        				p{transition: all 1.9s ease;}
        			}
        				border-bottom: solid 1px #e5e6e5;float: left;
        				border-right: solid 1px #e5e6e5;
        				img{width: 25%;margin-bottom: 10px;}
        				p{font-size: 16px;color: #fff;margin: 0;}
        				&:last-child{border: none;}
        				&:nth-child(2){border-right: none;}
        				&:nth-child(5){border-bottom: none;
        					
        				}
        			}
        		}
        		}
        	}
        	.text_box{
        		width: 45%;margin: auto;
        		p{
        			font-size: 16px;color: #fff;line-height: 1.8;
        		}
        	}
        	h3{font-size: 48px;color: #fff;margin-bottom: 44px;
        		@media (max-width: 1440px) {
        			font-size: 30px;
        		}
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #fff;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	
        }
        .content_icon{
        	width: 72.9%;margin:3vw auto;
        	h3{font-size: 48px;color: #ad1f24;margin: 44px 0;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #ad1f24;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	ul{
        		display: flex;padding: 1vw 0 2vw;flex-wrap: wrap;
        		li{
        			width: 32%;margin:20px 0.6666%;border: solid 1px #eee;
        			img{width: 100%;margin: auto;}
                    h4{font-size: 16px;text-align: left;padding: 0 6px;color:#ad1f24;margin-top: 10px;}
        			p{
        				font-size: 13px;color: #666;margin:10px 0 0 0;
        				text-align: left;padding: 0 6px 20px;
        			}
        			&:hover{
        				img{animation: jump22 0.5s ease-in-out infinite;}
        				
        			}
        		}
        	}
        }
        @keyframes jump {
        	0%,
        	100% {
        		transform: translateY(0);
        	}
        	50% {
        		transform: translateY(-10px);
        	}
        }
    }
	
</style>